import { Flyout } from '@itinerisltd/accessible-components';

(function ($) {

    // Run code when docuemnt is ready
    $(document).ready(function () {
      desktopNavigationFlyout();

      // Close the currently open dropdowns when Escape key is pressed
      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
          const focusedElement = document.activeElement;
          const openDropdown = focusedElement.closest('.sub-menu');
          if (!(openDropdown instanceof HTMLElement)) {
            return;
          }

          const parentItem = openDropdown.parentElement;
          if (!(parentItem instanceof HTMLElement)) {
            return;
          }

          openDropdown.style.display = 'none';
          parentItem.classList.remove('ast-submenu-expanded');
          parentItem.querySelector('button').focus();
        }
      });
    });
  })(jQuery);

  function desktopNavigationFlyout() {
    const desktopNav = document.getElementById('primary-site-navigation-desktop');
    if (!(desktopNav instanceof HTMLElement)) {
      return;
    }

    new Flyout('nav#primary-site-navigation-desktop', {
      menuItemSelector: 'li.menu-item-has-children',
      subMenuSelector: 'ul.sub-menu',
      menuLinkSelector: 'span.dropdown-menu-toggle',
    });
  }
